import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import FbSvg from '@/assets/icons/common/fb-icon.svg';
import InstagramSvg from '@/assets/icons/common/instagram-icon.svg';
import LinkedinSvg from '@/assets/icons/common/linkedin-icon.svg';
import TwitterSvg from '@/assets/icons/common/twitter-icon.svg';
import WhatsAppSvg from '@/assets/icons/common/whatsapp-icon.svg';

const Sidebar = ({ title, url }: { title: string; url: string }) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const shareLinks = [
    {
      name: 'Facebook',
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      iconPath: FbSvg,
      alt: 'Share on Facebook',
      rel: 'noopener noreferrer nofollow',
    },
    {
      name: 'Twitter',
      href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
      iconPath: TwitterSvg,
      alt: 'Share on Twitter',
      rel: 'noopener noreferrer nofollow',
    },
    {
      name: 'LinkedIn',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      iconPath: LinkedinSvg,
      alt: 'Share on LinkedIn',
      rel: 'noopener noreferrer nofollow',
    },
    {
      name: 'WhatsApp',
      href: `https://wa.me/?text=${encodedTitle} ${encodedUrl}`,
      iconPath: WhatsAppSvg,
      alt: 'Share on WhatsApp',
      rel: 'noopener noreferrer nofollow',
    },
    {
      name: 'Instagram',
      href: `https://www.instagram.com/collegehaiindia/profilecard/?igsh=NWt3aWUwZWtjcmtz`,
      iconPath: InstagramSvg,
      alt: 'Visit us on Instagram',
      rel: 'noopener noreferrer nofollow',
    },
  ];

  return (
    <div className="sticky bottom-0 !z-50 flex size-full max-w-screen-xl items-center justify-between rounded-lg bg-primary px-5 py-3 text-white lg:bottom-1 lg:py-4">
      <p className="text-xs md:text-sm">
        <span className="hidden sm:inline-block">Like what you see?</span> Share with a friend.
      </p>
      <div className="flex items-center gap-x-4 md:gap-x-6">
        {shareLinks.map(({ name, href, iconPath, alt }) => (
          <Link key={name} href={href} target="_blank" rel="noopener noreferrer nofollow" aria-label={alt}>
            <Image src={iconPath} alt={alt} width={24} height={24} className="invert" />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
